import React from 'react';
import NovaAvatar, { novaAvatarChapterFromSlug } from './NovaAvatar';

export { novaAvatarChapterFromSlug };

/**
 * Nova “N” avatar — chapter-colored fill, rings, italic Playfair letter.
 * @param {'fertility'|'ttc'} [chapter='fertility']
 * @param {number} [size=30]
 */
export default function NovaAvatarImg({ size = 30, chapter = 'fertility', style, className, alt = 'Nova' }) {
  return <NovaAvatar chapter={chapter} size={size} style={style} className={className} alt={alt} />;
}

/** SVG orb asset (legacy); inline Nova avatar uses CSS above. */
export const NOVA_AVATAR_SRC = '/images/nova-avatar.svg';
